import { OfficeWorkload } from '@office-start/officehome-types';
export function mapWorkloadToHarmonySessionSource(workload) {
    switch (workload) {
        case OfficeWorkload.Antp:
            return "unknown" /* HarmonySessionSource.Unknown */;
        case OfficeWorkload.Hwa:
            return "HarmonyDesktop" /* HarmonySessionSource.Desktop */;
        case OfficeWorkload.OfficeHome:
        case OfficeWorkload.OfficeHomeReact:
            return "HarmonyWeb" /* HarmonySessionSource.Web */;
        case OfficeWorkload.Embed:
            return "HarmonyEmbed" /* HarmonySessionSource.Embed */;
    }
}
//# sourceMappingURL=mapWorkloadToHarmonySessionSource.js.map